function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "btn_close");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "btn_close",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M33.1677571,26.0694613 L52.6880705,26.0694613 C54.6482108,26.0694613 56.2372184,27.6584689 56.2372184,29.6186092 C56.2372184,31.5787494 54.6482108,33.1677571 52.6880705,33.1677571 L33.1677571,33.1677571 L33.1677571,52.6880705 C33.1677571,54.6482108 31.5787494,56.2372184 29.6186092,56.2372184 C27.6584689,56.2372184 26.0694613,54.6482108 26.0694613,52.6880705 L26.0694613,33.1677571 L6.54914789,33.1677571 C4.58900764,33.1677571 3,31.5787494 3,29.6186092 C3,27.6584689 4.58900764,26.0694613 6.54914789,26.0694613 L26.0694613,26.0694613 L26.0694613,6.54914789 C26.0694613,4.58900764 27.6584689,3 29.6186092,3 C31.5787494,3 33.1677571,4.58900764 33.1677571,6.54914789 L33.1677571,26.0694613 Z",
  id: "Combined-Shape",
  fill: "#F0AB00",
  transform: "translate(29.618609, 29.618609) rotate(-315.000000) translate(-29.618609, -29.618609) "
}));

var SvgBtnClose = function SvgBtnClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBtnClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/btn-close.e28a1b3f.svg";
export { ForwardRef as ReactComponent };